import PropTypes from "prop-types";

import { RadioInputLabel } from "./styled";

const RadioInput = ({ id, name, checkedId, disabled, onCheck, children }) => {
  return (
    <RadioInputLabel checked={checkedId === id} disabled={disabled}>
      <span>
        <input
          id={`checkbox-${id}`}
          type="radio"
          name={name}
          checked={checkedId === id}
          disabled={disabled}
          onChange={() => onCheck(id)}
        />
      </span>
      <label htmlFor={`checkbox-${id}`}>{children}</label>
    </RadioInputLabel>
  );
};

RadioInput.propTypes = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  name: PropTypes.string.isRequired,
  checkedId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  disabled: PropTypes.bool,
  onCheck: PropTypes.func.isRequired,
  children: PropTypes.string
};

export default RadioInput;
